// extracted by mini-css-extract-plugin
export default {"orderContainer":"order_orderContainer__50f44"};